import script from "./ActivityLearn.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityLearn.vue?vue&type=script&setup=true&lang=js"

import "./ActivityLearn.vue?vue&type=style&index=0&id=0aff1675&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aff1675"]])

export default __exports__